import { Table, Text, Tooltip } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import {
	formatToCurrency,
	formatToDateString,
	formatToTimeString,
} from '../../util/formatting';
import { undefinedCheck } from '../../util/undefinedCheck';
import type { OperatorVoidDto } from './Types/OperatorVoidDto';

export function Voids() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const operatorVoidsQuery = queryWithFilterAndPages<OperatorVoidDto[]>(
		`${organisation}/operator-voids/all`,
		filter.value,
		pagination.value,
	);

	const operatorVoidsCountQuery = queryWithFilter<number>(
		`${organisation}/operator-voids/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Voids and No Sales'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={operatorVoidsCountQuery.data?.value ?? 100}
				isRowsLoading={operatorVoidsQuery.isLoading}
				isPaginationLoading={operatorVoidsCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Transaction No.'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Receipt No.'} />
						</Table.Th>
						<Table.Th miw={145}>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Amount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Description'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Type'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{operatorVoidsQuery.data?.value.map((operatorVoid) => (
						<KeyedRow key={operatorVoid.dateTime?.toString()}>
							<Table.Td>{undefinedCheck(operatorVoid.transactionNo)}</Table.Td>
							<Table.Td>{operatorVoid.receiptNo}</Table.Td>
							<Table.Td>{formatToDateString(operatorVoid.dateTime)}</Table.Td>
							<Table.Td>{formatToTimeString(operatorVoid.dateTime)}</Table.Td>
							<Table.Td>{operatorVoid.branch}</Table.Td>
							<Table.Td>{operatorVoid.operator}</Table.Td>
							<Table.Td>{formatToCurrency(operatorVoid.amount)}</Table.Td>
							<Table.Td>
								<Tooltip label={undefinedCheck(operatorVoid.description)}>
									<Text truncate size={'sm'} w={'10dvw'}>
										{undefinedCheck(operatorVoid.description)}
									</Text>
								</Tooltip>
							</Table.Td>
							<Table.Td>
								<Text truncate size={'sm'} w={'5dvw'}>
									{undefinedCheck(operatorVoid.type)}
								</Text>
							</Table.Td>
						</KeyedRow>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
